import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { collection, addDoc } from 'firebase/firestore'
import { db } from '../firebase-config/firebase'



const Create = () => {

  const [apellidos, setApellidos] = useState('')
  const [nombre, setNombre] = useState('')
  const [patologias, setPatologias] = useState('')
  const [cedula, setCedula] = useState(0)
  const [edad, setEdad] = useState('') 
  const citas = []
  const recetas = []
  const navigate = useNavigate()

  const adultosmCollection = collection(db, "adultosm")

  const store = async (e) => {
 
    e.preventDefault()
    await addDoc(adultosmCollection, {
      apellidos: apellidos,
      nombre: nombre,
      cedula: cedula,
      patologias: patologias,
      edad: edad,
      citas: citas,
      recetas: recetas
    })
    navigate('/home')
  }

  return (
    <div className="container">

      <div className='Header'>
        <div className="row"> <h1>Ingresar Adulto</h1> </div>
        <div className='underlineC'></div>
      </div>

      <div className="row">

        <div className="col">


          <section className='container my-2 bg-dark w-adapt text-light p-2 rcorners'>
            <form onSubmit={store} className='p-4 row g-2 formShadow'>
              
              <div className='mb-3'>
                <label className='form-label'>Nombre</label>
                
                <input
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  type="text"
                  className='form-control'

                />
              </div> 
              <div className='mb-3'>
                <label className='form-label'>Apellidos</label>
                <input
                  value={apellidos}
                  onChange={(e) => setApellidos(e.target.value)}
                  type="text"
                  className='form-control'

                />

              </div>

              <div className='mb-3'>
                <label className='form-label'>Patologias</label>
               
                <input
                  value={patologias}
                  onChange={(e) => setPatologias(e.target.value)}
                  type="text"
                  className='form-control'
                /> 
                
              </div>

              <div className='mb-3'>
                <label className='form-label'>Cedula</label>
                <input
                  value={cedula}
                  onChange={(e) => setCedula(e.target.value)}
                  type="number"
                  className='form-control'

                />

              </div>
              <div className='mb-3'>
                <label className='form-label'>Fecha de nacimiento</label>
                <input
                  value={edad}
                  onChange={(e) => setEdad(e.target.value)}
                  placeholder="Seleccionar fecha"
                  type="date"
                  className='form-control'

                />
              </div>
              <button type='submit' className='submit'>Ingresar</button>


            </form>
          </section>


        </div>

      </div>
    </div>

  )
}

export default Create